import moment from 'moment-timezone';
import { printTimezones } from 'src/app/constants/timezones';

export const DATE_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';

export function getDateAsUtc(d: Date) {
  return moment.utc(d).toDate();
}

export function getFirstDayOfMonth(date: Date): Date {
  const retVal = new Date(date);
  retVal.setDate(1);
  return retVal;
}

export function getLogIdFromDate() {
  return moment.tz(moment.tz.guess()).format('YYYYMMDD-HHmmssSSS');
}

export function getUserTimezone() {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let match = printTimezones.find((tz) => tz.value === userTimezone);

  if (!match) {
    let offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const sign = offsetMinutes > 0 ? '-' : '+';
    offsetMinutes = Math.abs(offsetMinutes) % 60;

    // Format the offset as UTC +/-HH:MM
    return `UTC${sign}${String(offsetHours).padStart(2, '0')}:${String(
      offsetMinutes
    ).padStart(2, '0')}`;
  }

  return match.label;
}
